<template>
    <Modal v-model="modal" title="修改密码" :footer-hide="true">
        <Spin fix v-if="spinShow"></Spin>
        <Form ref="password" :model="password" :rules="ruleValidate" :label-width="110" label-colon="：">
            <FormItem label="原密码" prop="old">
                <Input v-model="password.old" placeholder="请输入原密码" style="width: 100%" type="password" />
            </FormItem>
            <FormItem label="新密码" prop="new">
                <Input v-model="password.new" placeholder="请输入新密码" style="width: 100%" type="password" />
            </FormItem>
            <FormItem label="重复新密码" prop="newTwo">
                <Input v-model="password.newTwo" placeholder="请重复输入新密码" style="width: 100%" type="password" />
            </FormItem>
        </Form>
        <div style="margin-top:5px;text-align:center">
            <Button type="primary" style="width:80%" @click="modalSave">保存</Button>
        </div>
    </Modal>
</template>
<script>
import api from '@/api/index';

export default {
    props: {
        show: Object
    },
    watch: {
        show(val, oldVal) {
            this.clearValidate();
            this.modal = val.show;
        }
    },
    data() {
        return {
            modal: false,
            spinShow: false,
            password: {
                old: '',
                new: '',
                newTwo: ''
            },
            ruleValidate: {
                old: [
                    { required: true, message: '请输入原密码', trigger: 'blur' }
                ],
                new: [
                    { required: true, message: '请输入新密码', trigger: 'blur' }
                ],
                newTwo: [
                    { required: true, message: '请重复输入新密码', trigger: 'blur' },
                    { validator: (rule, value, callback) => { return this.password.new === this.password.newTwo; }, message: '两次密码不一致', trigger: 'blur' }
                ]
            }
        };
    },
    methods: {
        modalSave() {
            this.$refs.password.validate((valid) => {
                if (!valid) {
                    return;
                }
                this.modalNextVerifyPageNews();
            });
        },
        async modalNextVerifyPageNews() {
            this.spinShow = true;
            const user = localStorage.getItem('CMSUserName');
            const res = await api.changePassword(user, this.password.old, this.password.new);
            this.spinShow = false;
            if (res.code !== 200) {
                this.$Message.error('修改失败！');
                return;
            }
            this.$Message.info('修改成功！');
            this.modal = false;
        },
        clearValidate() {
            this.password = {
                old: '',
                new: '',
                newTwo: ''
            };
            window.setTimeout(() => {
                this.$refs.password.resetFields();
            }, 0);
        }
    }
};
</script>

<style scoped lang="scss">
.h100 {
    height: 100%;
}
.selfRolling {
    height: 100%;
    overflow: auto;
}
.modal-title {
    text-align: center;
    font-size: 20px;
    padding-bottom: 10px;
}
</style>
<style scoped>
.selfRolling >>> .ivu-form-item {
    margin-bottom: 0px;
}
.selfRolling >>> .quill-editor {
    height: 100%;
    display: flex;
    flex-direction: column;
}
</style>
